module.exports = __webpack_public_path__ + "static/media/carta_24.cf2b7d3d.jpg";